module.exports = __webpack_public_path__ + "static/img/ratio3.faed3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2-coupon/ratio3.png
// module id = b/a6
// module chunks = 12